import { StyledLogo } from './style';

const customLogoMaxHeight: { [key: string]: string } = {
  'wheel-fortune-bmi-valentines-day': '160px',
  'wheel-fortune-loste': '160px',
  default: '68px',
};

interface TLogoCardProps {
  logoSrc: string;
  gameAnimationType: string;
}

const LogoCard = ({ logoSrc, gameAnimationType }: TLogoCardProps) => {
  const maxHeight = customLogoMaxHeight[gameAnimationType] || customLogoMaxHeight.default;

  return <StyledLogo src={logoSrc} $maxHeight={maxHeight} />;
};

export default LogoCard;
